<ion-row>
  <ion-col size="12" *ngIf="valgtAnlegg">
    <ion-row class="cost-info-row">
      <ion-col *ngIf="ifjorResponse | async as ifjor; else loadingTemplate" size="12" sizeSm="6"
        [class.ion-hide]="!hasIfjor(ifjor, valgtAnlegg.objectid)">
        <ion-row *ngIf="hasIfjor(ifjor, valgtAnlegg.objectid)">
          <ion-col class="box-col-nokkeltall mb-3 mr-3-md">
            <div *ngIf="hasIfjor(ifjor, valgtAnlegg.objectid)" class="mb-4-md">
              <p>
                {{ capFirst(selectedPeriod) }}
                {{ comparePeriod(selectedDate) }}*
              </p>
              <p *ngIf="isPlusskunde">Forbruk</p>
              <p class="large-number-total">
                {{ toRoundNumber(getIFjor(ifjor, valgtAnlegg.objectid)) }} kWh
              </p>
              <div class="flex-row">
                <p>Laveste dag</p>
                <p>
                  {{
                  toRoundNumber(getIfjorLowest(ifjor, valgtAnlegg.objectid))
                  }}
                  kWh
                </p>
              </div>
              <div class="flex-row">
                <p>Høyeste dag</p>
                <p>
                  {{
                  toRoundNumber(getIfjorHighest(ifjor, valgtAnlegg.objectid))
                  }}
                  kWh
                </p>
              </div>
              <div class="flex-row">
                <p>Daglig snitt</p>
                <p>
                  {{
                  toRoundNumber(getIfjorSnitt(ifjor, valgtAnlegg.objectid))
                  }}
                  kWh
                </p>
              </div>
              <div class="flex-row" *ngIf="isPlusskunde">
                <p>Produksjon</p>
                <p>
                  {{
                  toRoundNumber(getIFjorPluss(ifjor, valgtAnlegg.objectid))
                  }}
                  kWh
                </p>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-col size="12" sizeSm="6">
        <ion-row>
          <ion-col class="box-col-nokkeltall mr-3-lg">
            <div class="mb-4-md">
              <p *ngIf="!hasCompleteMonth">
                Estimert {{ selectedPeriod }} {{ thisPeriod(selectedDate) }}*
              </p>
              <p *ngIf="hasCompleteMonth">
                {{ capFirst(selectedPeriod) }} {{ thisPeriod(selectedDate) }}*
              </p>
              <p *ngIf="isPlusskunde">Forbruk</p>
              <p class="large-number-total">
                {{ toRoundNumber(estimateForbruk) }} kWh
              </p>

              <div class="flex-row">
                <p>Laveste dag</p>
                <p>{{ toRoundNumber(lowestForbruk) }} kWh</p>
              </div>
              <div class="flex-row">
                <p>Høyeste dag</p>
                <p>{{ toRoundNumber(highestForbruk) }} kWh</p>
              </div>
              <div class="flex-row">
                <p>Daglig snitt</p>
                <p>{{ toRoundNumber(avgForbruk) }} kWh</p>
              </div>
              <div class="flex-row" *ngIf="isPlusskunde">
                <p>Produksjon {{ !hasCompleteMonth ? 'hittil' : '' }}</p>
                <p>{{ toRoundNumber(produksjon) }} kWh</p>
              </div>
              <div class="flex-row" *ngIf="isPlusskunde && !hasCompleteMonth">
                <p>Forbruk hittil</p>
                <p>{{ toRoundNumber(forbruk) }} kWh</p>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>

<ng-template #loadingTemplate>
  <ion-col class="mr-3">
    <div class="loadingContainer">
      <ion-spinner name="dots"></ion-spinner>
    </div>
  </ion-col>
</ng-template>